module.exports = __webpack_public_path__ + "static/media/paquete2.3943501d.JPG";